export function OutlineKanbanIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4 19.2C17.4 20.1941 18.2059 21 19.2 21C20.1941 21 21 20.1941 21 19.2L21 4.8C21 3.80589 20.1941 3 19.2 3C18.2059 3 17.4 3.80589 17.4 4.8V19.2Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2 9.99883C10.2 10.9929 11.0059 11.7988 12 11.7988C12.9942 11.7988 13.8 10.9929 13.8 9.99883V4.80043C13.8 3.80632 12.9942 3.00043 12 3.00043C11.0059 3.00043 10.2 3.80632 10.2 4.80043V9.99883Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.0001 15.0008C3.0001 15.9949 3.80599 16.8008 4.8001 16.8008C5.79421 16.8008 6.6001 15.9949 6.6001 15.0008L6.6001 4.80078C6.6001 3.80667 5.79421 3.00078 4.8001 3.00078C3.80599 3.00078 3.0001 3.80667 3.0001 4.80078L3.0001 15.0008Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
